'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TreeItemLayout", {
    enumerable: true,
    get: function() {
        return TreeItemLayout;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTreeItemLayout = require("./useTreeItemLayout");
const _renderTreeItemLayout = require("./renderTreeItemLayout");
const _useTreeItemLayoutStylesstyles = require("./useTreeItemLayoutStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const TreeItemLayout = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTreeItemLayout.useTreeItemLayout_unstable)(props, ref);
    (0, _useTreeItemLayoutStylesstyles.useTreeItemLayoutStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useTreeItemLayoutStyles_unstable')(state);
    return (0, _renderTreeItemLayout.renderTreeItemLayout_unstable)(state);
});
TreeItemLayout.displayName = 'TreeItemLayout';
